// Importowanie komponentów
import textRotateComponent from "./text-rotate.jsx";
import marqueeComponent from "./marquee.jsx";
import underlineAnimationComponent from "./underline-animation.jsx";
import animatedGroupComponent from "./animated-group.jsx";
import numberTickerComponent from "./number-ticker.jsx";
import linkPreviewComponent from "./link-preview.jsx";

// Lista wszystkich komponentów
const components = [
  animatedGroupComponent,
  numberTickerComponent,
  linkPreviewComponent,
  textRotateComponent,
  marqueeComponent,
  underlineAnimationComponent,

  // Tutaj można dodać więcej komponentów po ich stworzeniu
];

// Funkcja do pobierania komponentu według ID
export const getComponentById = (id) => {
  return components.find((component) => component.id === id) || null;
};

// Eksport listy komponentów
export default components;
